/* eslint-disable */
import { openModal } from '../../../../modal-container/clientlibs/site/js/modal-container.js';
import { setCenteredMaxWidth } from 'js/helpers.js';

const ALL_RESULT = 'all';
const PRODUCTS = 'products';
const LIFECYCLE = 'lifecycle';
const DOCUMENTS = 'documents';
const DOWNLOADS = 'downloads';
const TABS = [PRODUCTS, DOCUMENTS, DOWNLOADS, ALL_RESULT];
const defaultDictionary = {
    'ACTIVE': 'Active',
    'DISCONTINUED': 'Discontinued',
    'ACTIVE_MATURE': 'Active Mature',
    'END_OF_LIFE': 'End of Life',
    'MANAGED': 'Managed',
    'productType': 'Product Type',
    'documentType': 'Document Type',
    'product': 'Product',
    'productFamily': 'Product Family',
    'lifeCycle': 'Life Cycle',
    'HARDWARE': 'Hardware',
    'SOFTWARE': 'Software',
};

// Default item size on all result page
const downloadSize = 3;
const productSize = 4;
const documentSize = 3;

const searchResultAppId = 'search-result-app';
const searchResultAppElement = document.getElementById(searchResultAppId);
const dictionary = JSON.parse(searchResultAppElement?.getAttribute('data-dictionary')) || defaultDictionary;
const clientId = searchResultAppElement.getAttribute('data-client-id');
const clientSecret = searchResultAppElement.getAttribute('data-client-secret');
const correlationId =searchResultAppElement.getAttribute('data-correlation-id') + '-' +(crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);
const baseUrl = searchResultAppElement.getAttribute('data-base-url');
const bestMatchLabel = searchResultAppElement.getAttribute('data-best-match-label');
const alphabeticalAzLabel = searchResultAppElement.getAttribute('data-alphabetical-az-label');
const alphabeticalZaLabel = searchResultAppElement.getAttribute('data-alphabetical-za-label');
const aiQueryEndpoint = searchResultAppElement.getAttribute('data-ai-query-endpoint');
const aiClientId = searchResultAppElement.getAttribute('data-ai-client-id');
const aiClientSecret = searchResultAppElement.getAttribute('data-ai-client-secret');
const aiCorrelationId = searchResultAppElement.getAttribute('data-ai-correlation-id');
const sampleCodeDownloadModal = document.getElementById('modal-sample-code-download');

const loadingcomponent = {
    props: {
        width: {
            type: String,
            default: '200px'
        },
        height: {
            type: String,
            default: '100px'
        },
        rounded: {
            type: Boolean,
            default: false
        }
    },
    template: `<div class="loading" :style="{ width: width, height: height, borderRadius: rounded ? '4px' : '0' }"></div>`
};

const app = Vue.createApp({
    components: {
        loadingcomponent
    },
    data() {
        return {
            keyword : '',
            activeTab: ALL_RESULT,
            defaultTab: ALL_RESULT,
            count: 0,
            results: [],
            locale: document.querySelector('html').getAttribute('lang').replace('-__', '') || 'en-US',
            itemsPerPage: 25,
            currentPage: 0,
            filters: {},
            collapsedCategories: new Set(),
            sortBy: '',
            clientId: clientId,
            clientSecret: clientSecret,
            correlationId: correlationId,
            baseUrl: baseUrl,
            loading: true,
            windowWidth: window.innerWidth,
            mobileSize: 1024,
            aiEnabled: document.querySelector('#search-result-app').getAttribute('data-ai-enabled') === 'true',
            aiMinCharacters: document.querySelector('#search-result-app').getAttribute('data-ai-min-characters') || 5,
            aiMinWords: document.querySelector('#search-result-app').getAttribute('data-ai-min-words') || 3,
            aiMaxCharacters: document.querySelector('#search-result-app').getAttribute('data-ai-max-characters') || 2048,
            aiValidQuery: false,
            aiLoading: true,
            aiRelatedLinksLoading: true,
            aiResponse: '',
            aiResponseMaxHeight: 144,
            aiResponseMaxHeightExpanded: 144,
            summarizeLength: 50,
            relatedLinks: [],

            lifecycleView: document.querySelector('#search-result-app').getAttribute('data-lifecycle-view') === 'true',
            discontinuedDateLabel: document.querySelector('#search-result-app').getAttribute('data-discontinued-date-label') || 'Discontinued Date',
            replacementCategoryLabel: document.querySelector('#search-result-app').getAttribute('data-replacement-category-label') || 'Replacement Category',
            replacementLabel: document.querySelector('#search-result-app').getAttribute('data-replacement-label') || 'Replacement',
            ALL_RESULT,
            PRODUCTS,
            LIFECYCLE,
            DOCUMENTS,
            DOWNLOADS,
            TABS,
            downloadSize,
            productSize,
            documentSize,
        };
    },
    created() {
        window.addEventListener('resize', this.handleResize);

        const urlParams = new URLSearchParams(window.location.search);
        this.keyword = urlParams.has('keyword') ? urlParams.get('keyword') : '';
        if (urlParams.has('filters')) {
            const defaultFilters = urlParams.get('filters');
            if (defaultFilters) {
                this.filters = defaultFilters.split('--').reduce((obj, key) => {
                    key = key.trim();
                    if (key) obj[key] = true;
                    return obj;
                }, {});
            }
        }
        if (this.lifecycleView) {
            this.defaultTab = LIFECYCLE;
            this.activeTab = LIFECYCLE;
            this.itemsPerPage = 24;
        } else {
            const selectedTab = urlParams.get('tab')?.toLowerCase() || ALL_RESULT;
            switch (selectedTab) {
                case PRODUCTS:
                case LIFECYCLE:
                case DOWNLOADS:
                case DOCUMENTS:
                    this.defaultTab = selectedTab;
                    break;
                default:
                    this.defaultTab = ALL_RESULT;
                    break;
            }
        }
    },

    mounted() {
        if (this.lifecycleView && this.keyword) {
            this.fetchTabResults(this.defaultTab)
                .catch(error => console.error('Error fetching lifecycle view results:', error));
        } else if (!this.lifecycleView) {
            this.fetchAllResults(this.keyword)
                .then(() => this.changeTab(this.defaultTab, true))
                .catch(error => console.error('Error fetching all results:', error));
        } else {
            this.loading = false;
        }

        if (this.aiEnabled && this.keyword) {
            try {
                this.fetchAiResults();
            } catch (e) {
                console.warn('Error fetching AI results', e);
                this.aiLoading = false;
                this.aiRelatedLinksLoading = false;
            }
        }
        document.addEventListener('click', e => {
            this.closeDetailsElement(e);
        });
    },
    unmounted() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        isMobile(newValue, oldValue) {
            if (newValue !== oldValue) {
                if (newValue) {
                    this.addAllCategories();
                } else {
                    this.resetCollapsedCategories();
                }
            }
        },
        activeFilterKeys(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.setQueryParam("filters", newValue.join('--'));
            }
        }
    },
    computed: {
        isMobile() {
            return this.windowWidth <= this.mobileSize;
        },
        activeFilterKeys() {
            return Object.keys(this.filters).filter(key => this.filters[key]);
        },

        showTabs() {
            return !this.lifecycleView;
        },

        showProductTypeFilter() {
            return !this.lifecycleView;
        },

        shouldShowComponent() {
            if (!this.lifecycleView) {
                return true;
            }
            return this.keyword && this.keyword.trim() !== '';
        },

        hasResults() {
            if (this.loading) {
                return false;
            }

            if (this.lifecycleView) {
                const lifecycleData = this[LIFECYCLE];
                return lifecycleData && lifecycleData.total > 0;
            } else if (this.activeTab === ALL_RESULT) {
                const allResults = this.getAllResults(ALL_RESULT);
                return allResults && allResults.total > 0;
            } else {
                const tabResults = this.getTabResults(this.activeTab);
                return tabResults && tabResults.total > 0;
            }
        }
    },
    methods: {
        setQueryParam(key, value) {
            const url = new URL(window.location.href);
            if (value === undefined || value === null || value === '') {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, value);
            }
            window.history.pushState({}, '', url);
        },
        handlePaginationInput(event) {
            const input = event.target;
            const inputError = input.parentElement?.querySelector('.pagination-error');
            if (!inputError) return;
            if (!inputError.classList.contains('is-visible')) {
                return;
            }
            if (input.validity.valid) {
                inputError.classList.remove('is-visible');
                inputError.style.removeProperty('--pagination-error-max-width');
            } else {
                input.checkValidity();
            }
        },
        handlePaginationInvalid(event) {
            event.preventDefault();
            const input = event.target;
            const inputError = input.parentElement?.querySelector('.pagination-error');
            const errorText = inputError?.querySelector('.pagination-error-text');

            if (!inputError || !errorText) return;

            inputError.classList.add('is-visible');
            const validity = input.validity;

            if (validity.rangeUnderflow) {
                errorText.textContent = `${input.dataset.errorMin}  ${input.min}`;
            } else if (validity.rangeOverflow) {
                errorText.textContent = `${input.dataset.errorMax}  ${input.max}`;
            } else if (validity.badInput || validity.typeMismatch) {
                errorText.textContent = input.dataset.errorNumber;
            } else {
                errorText.textContent = input.validationMessage;
            }

            setCenteredMaxWidth(input, inputError, '--pagination-error-max-width');

            if (!this._paginationRestoreHandler) {
                this._paginationRestoreHandler = (e) => {
                    if (!input.contains(e.target)) {
                        if (inputError.classList.contains('is-visible')) {
                            input.value = this.currentPage + 1;
                            inputError.classList.remove('is-visible');
                            inputError.style.removeProperty('--pagination-error-max-width');
                        }
                        document.removeEventListener('pointerdown', this._paginationRestoreHandler);
                        this._paginationRestoreHandler = null;
                    }
                };
                setTimeout(() => document.addEventListener('pointerdown', this._paginationRestoreHandler), 0);
            }
        },
        handlePaginationBlur(event) {
            const input = event.target;
            if (Number(input.value) !== this.currentPage + 1) {
                input.closest('form').requestSubmit();
            }
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        getFormattedDate(date) {
            try {
                const dateObj = new Date(date);
                const options = { year: 'numeric', month: 'short', day: 'numeric' };
                return new Intl.DateTimeFormat(this.locale, options).format(dateObj);
            } catch (e) {
                return date;
            }
        },

        getFormattedDiscontinuedDate(date) {
            if (!date) return 'N/A';
            try {
                const dateObj = new Date(date);
                const options = { year: 'numeric', month: 'numeric', day: 'numeric', timeZone: 'UTC' };
                return new Intl.DateTimeFormat(this.locale, options).format(dateObj);
            } catch (e) {
                return date;
            }
        },
        getFormattedReplacementCategory(replacementCategory){
            return replacementCategory.replaceAll('_', ' ');
        },
        isCountryInSalesOrg(salesOrg) {
            if (!salesOrg?.length) {
                return false;
            }

            const currentCountry = document.querySelector('html')
                ?.getAttribute('lang')
                ?.split('-')[1]
                ?.toLowerCase();

            if (!currentCountry) {
                return false;
            }
            return salesOrg.some(org =>
                org?.countryCode?.toLowerCase() === currentCountry
            );
        },

        shouldShowAsLink(resultItem) {
            return this.isCountryInSalesOrg(resultItem?.salesOrg);
        },

        getFormattedTotal(count) {
            return count === 10000 ? count + '+' : count;
        },

        getDisplayName(key) {
            if (key === 'type') {
                switch (this.activeTab) {
                    case PRODUCTS:
                    case LIFECYCLE:
                        key = 'productType';
                        break;
                    case DOCUMENTS:
                        key = 'documentType';
                        break;
                    default:
                        break;
                }
            }
            return dictionary.hasOwnProperty(key) ? dictionary[key] : key;
        },

        getFilterName(key) {
            const filterName = key.includes(':') ? key.substring(key.indexOf(':') + 1) : '';
            return this.getDisplayName(filterName);
        },

        getTitle(resultItem) {
            return [resultItem.catalogNumber, resultItem.title].filter(Boolean).join(' — ');
        },

        highlightKeyword(text, keyword) {
            const regex = new RegExp(`(${keyword})`, 'gi');
            return text && text.replace(regex, '<strong>$1</strong>');
        },

        hasReplacementInfo(product) {
            return product.discontinuedDate ||
                   product.replacementCategory ||
                   product.replacementUrl ||
                   product.replacementText;
        },

        getReplacementUrl(catalogNumber) {
            if (!catalogNumber) return null;

            const urlLocale = (document.querySelector('html')?.getAttribute('lang') || 'en-US').toLowerCase();
            let baseUrl = 'https://www.rockwellautomation.com';

            if (urlLocale === "zh-cn") {
                baseUrl = 'https://www.rockwellautomation.com.cn';
            }

            return `${baseUrl}/${urlLocale}/products/details.${catalogNumber}.html`;
        },

        changeItemsPerPage(newValue) {
            const oldItemsPerPage = this.itemsPerPage;
            this.itemsPerPage = parseInt(newValue);
            const currentFirstItem = this.currentPage * oldItemsPerPage;
            this.currentPage = Math.floor(currentFirstItem / this.itemsPerPage);
            this.fetchTabResults(this.activeTab);
        },

        fetchAllResults(keyword) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("client_id", this.clientId);
            myHeaders.append("client_secret", this.clientSecret);
            myHeaders.append("correlation_id", this.correlationId);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };
            const baseUrl = this.baseUrl;
            const url = this.getQueryUrl(baseUrl, this.activeTab);

            this.loading = true;
            return fetch(url, requestOptions)
                .then(response => response.json())
                .then(results => {
                    this.results = results;

                    if (this.results && Array.isArray(this.results)) {
                        try {
                            this.results.forEach(group => {
                               if (Array.isArray(group.docs)) {
                                    this.cleanProductURLs(group.docs);
                                }
                            });
                        } catch (e) {
                            console.error('Error processing results:', e);
                        }
                    }
                })
                .catch(error => console.error('Fetch all results error:', error))
                .finally(() => this.loading = false);
        },

        fetchTabResults(tab) {
            if (tab === ALL_RESULT) {
                this.fetchAllResults(this.keyword);
                return Promise.resolve();
            }

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            myHeaders.append("client_id", this.clientId);
            myHeaders.append("client_secret", this.clientSecret);
            myHeaders.append("correlation_id", this.correlationId);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            };

            const baseUrl = this.baseUrl;
            const url = this.getQueryUrl(baseUrl, tab);

            this.loading = true;

            return fetch(url, requestOptions)
                .then(response => response.json())
                .then(results => {
                    this[tab] = results;

                    if (this[tab].docs) {
                        try {
                            this.cleanProductURLs(this[tab].docs);
                        } catch (e) {
                            console.error('Error cleaning URLs:', e);
                        }
                    }
                })
                .catch(error => console.error('Fetch tab results error:', error))
                .finally(() => this.loading = false);
        },

        getQueryUrl(baseUrl, tab) {
            const filterPairs = this.getFilterPairs();
            const url = new URL(baseUrl);
            const params = new URLSearchParams(url.search);

            params.set("query", this.keyword);

            if (tab != ALL_RESULT) {
                params.set("tab", tab);
            } else {
                params.set("fromDownloads", this.currentPage * downloadSize);
                params.set("fromProducts", this.currentPage * productSize);
                params.set("fromDocuments", this.currentPage * documentSize);
                params.set("sizeDownloads", downloadSize);
                params.set("sizeProducts", productSize);
                params.set("sizeDocuments", documentSize);
            }

            params.set("from", this.currentPage * this.itemsPerPage);
            params.set("size", this.itemsPerPage);
            params.set("locale", this.locale);

            if (this.sortBy) {
                params.set("alphaSort", this.sortBy);
            }

            for (const [key, value] of Object.entries(filterPairs)) {
                params.set(key, JSON.stringify(value));
            }

            url.search = params.toString();
            return url.toString();
        },

        getFilterPairs() {
            const output = {};
            for (const [key, value] of Object.entries(this.filters)) {
                if (value) {
                    const [category, val] = key.split(':');
                    const paramName = category;
                    if (!output[paramName]) {
                        output[paramName] = [];
                    }
                    output[paramName].push(val);
                }
            }
            return output;
        },

        cleanProductURLs(docs) {
            var urlLocale = (document.querySelector('html')?.getAttribute('lang') || 'en-US').toLowerCase();

            docs.forEach(doc => {
                if (doc?.url && doc.url.indexOf("/products/details.") !== -1 && urlLocale !== "en-us") {
                    if (urlLocale === "zh-cn") {
                        doc.url = doc.url.replace('.com/', '.com.cn/');
                    }
                    doc.url = doc.url.replace('/en-us/', `/${urlLocale}/`);
                }
                if (doc?.replacementUrl && doc.replacementUrl.indexOf("/products/details.") !== -1 && urlLocale !== "en-us") {
                    if (urlLocale === "zh-cn") {
                        doc.replacementUrl = doc.replacementUrl.replace('.com/', '.com.cn/');
                    }
                    doc.replacementUrl = doc.replacementUrl.replace('/en-us/', `/${urlLocale}/`);
                }
            });
        },
        getAllResults(itemType) {
            return this.results.find(item => item.tab === itemType) || {};
        },

        getAllResultItems(itemType) {
            const result = this.getAllResults(itemType);
            return result && result.docs ? result.docs : [];
        },

        getTabResults(itemType) {
            return this.activeTab === ALL_RESULT ? this.getAllResults(itemType) : this[itemType];
        },

        getResultItems(itemType) {
            const result = this.getTabResults(itemType);
            return result && result.docs ? result.docs : [];
        },

        getTabFilterFacets(itemType) {
            const result = this.getTabResults(itemType);
            let facets = result?.facets;

            if (this.activeTab === DOWNLOADS) {
                facets = Object.fromEntries(Object.entries(result.facets).reverse());
            }

            return result && facets ? facets : [];
        },
        setFilter(category, option, isEnabled) {
            let filter = [];
            if (this.filters[category + "Vals"]) {
                filter = this.filters[category + "Vals"];
            }
            this.filters[category + "Vals"] = filter;
        },

        showClearAll() {
            return Object.values(this.filters).some(value => value === true);
        },

        clearFilter() {
            this.filters = {};
            this.fetchTabResults(this.activeTab);
        },

        applyFilter(tab) {
            if (!this.isMobile) {
                this.currentPage = 0;
                this.fetchTabResults(tab);
            }
        },

        getSortedBuckets(buckets, category) {
            return buckets.sort((a, b) => {
                const aSelected = this.isFacetSelected(category, a);
                const bSelected = this.isFacetSelected(category, b);

                if (aSelected && !bSelected) return -1;
                if (!aSelected && bSelected) return 1;

                return a.key.localeCompare(b.key);
            });
        },

        isFacetSelected(category, bucket) {
           return this.filters[category+':'+bucket.key];
        },
        changeTab(tab, keepFilters = false) {
            if (tab == this.activeTab && !keepFilters) {
                return;
            }

            this.activeTab = tab;
            this.currentPage = 0;

            if (!keepFilters) {
                this.filters = {};
            }

            this.sortBy = '';
            this.collapsedCategories = new Set();

            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('tab', tab);
            window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);

            if (this.activeTab != ALL_RESULT) {
                this.fetchTabResults(tab);
            } else {
                this.itemsPerPage = 25;
            }
        },

        goToPage(pageNumber = 1) {
            if (pageNumber >= 0 && pageNumber < this.maxPage()) {
                this.currentPage = pageNumber;
                this.fetchTabResults(this.activeTab);
                setTimeout(() => window.scrollTo(0, 0), 10);
            }
        },

        submitPage(event) {
            event.preventDefault();
            const pageNumber = Number(event.target.elements.input.value) - 1;
            this.goToPage(Number.isNaN(pageNumber) ? this.currentPage : pageNumber);
        },

        maxPage() {
            try {
                return Math.ceil((this.getTabResults(this.activeTab)?.total ?? 0) / this.itemsPerPage);
            } catch (e) {
                return 0;
            }
        },

        hasPrev() {
            return this.currentPage - 1 >= 0;
        },

        hasNext() {
            return this.currentPage + 1 < this.maxPage();
        },
        updateSort(sortOption) {
            this.sortBy = sortOption;
            if (!this.isMobile) {
                this.fetchTabResults(this.activeTab);
            }
            this.$refs.detailsElement.open = false;
        },

        getSortByLabel() {
            switch (this.sortBy) {
                case 'asc':
                    return alphabeticalAzLabel;
                case 'desc':
                    return alphabeticalZaLabel;
                default:
                    return bestMatchLabel;
            }
        },
        isCollapsed(category) {
            return this.collapsedCategories.has(category);
        },

        toggleCategory(category) {
            if (this.isCollapsed(category)) {
                this.collapsedCategories.delete(category);
            } else {
                this.collapsedCategories.add(category);
            }
        },

        addAllCategories() {
            const facets = this.getTabFilterFacets(this.activeTab);
            this.collapsedCategories.add('sort');
            for (const [category, bucket] of Object.entries(facets)) {
                this.collapsedCategories.add(category);
            }
        },

        resetCollapsedCategories() {
            this.collapsedCategories = new Set();
        },

        closeDetailsElement(e) {
            if (this.$refs.detailsElement?.open === true && !this.$refs.detailsElement?.contains(e.target)) {
                this.$refs.detailsElement.open = false;
            }
        },

        toggleFilterLeftActive() {
            this.$refs.filterLeft.classList.toggle('Active');
            const isOpened = this.$refs.filterLeft.classList.contains('Active');
            if (!isOpened) {
                this.fetchTabResults(this.activeTab);
            }
        },

        mobileTooltipHandler(event) {
            if (this.isMobile) {
                event.stopPropagation();
                const tooltip = event.target.closest('.filter__tooltip');
                const tooltipContent = tooltip.querySelector('.filter__tooltip-content');

                tooltipContent.style.display = 'unset';
                tooltipContent.style.visibility = 'visible';
                tooltipContent.style.opacity = '1';
                tooltipContent.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start'
                });

                setTimeout(() => {
                    tooltipContent.style.visibility = 'hidden';
                    tooltipContent.style.display = 'none';
                }, 4000);
            }
        },

        expandAiSummary() {
            document.querySelector('.ai-summary__overview-content-text-container').classList.toggle('active');
            document.querySelector('.ai-summary__overview-content-show-more').classList.toggle('active');
        },
        handleSampleCodeDownloads(originalDownloadLink) {
            if (!originalDownloadLink.includes('resources/downloads/samplecode')) {
                window.location.href = originalDownloadLink;
            } else {
                const newDownloadLink = document.createElement("a");
                newDownloadLink.setAttribute('href', originalDownloadLink);
                newDownloadLink.setAttribute('download', true);
                newDownloadLink.setAttribute('download', '');

                const modalButton = sampleCodeDownloadModal.querySelector('button.disclaimer__accept-button');
                const newAcceptButton = modalButton.cloneNode(true);
                modalButton.parentNode.replaceChild(newAcceptButton, modalButton);

                newAcceptButton.addEventListener('click', () => {
                    newDownloadLink.click();
                    sampleCodeDownloadModal.close();
                });

                openModal(sampleCodeDownloadModal);
            }
        },
        async fetchAiResults() {
            if (this.keyword.length < this.aiMinCharacters || this.keyword.length > this.aiMaxCharacters || this.keyword.split(' ').length < this.aiMinWords) {
                return;
            }
            try {
                const regionMap = {
                    na: ['ca', 'us'],
                    emea: ['at', 'be', 'ch', 'cz', 'de', 'dk', 'es', 'fi', 'fr', 'gb', 'hu', 'ie', 'il', 'it', 'mde', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'se', 'tr', 'ua', 'za'],
                    latam: ['ar', 'br', 'co', 'mx', 'pr'],
                    apac: ['au', 'cn', 'id', 'in', 'jp', 'kr', 'nz', 'sg', 'tw'],
                }
                const language = document.querySelector('html').getAttribute('lang').split('-')[0];
                const country = document.querySelector('html').getAttribute('lang').split('-')[1].toLowerCase();
                const locale = document.querySelector('html').getAttribute('lang');
                let region = 'na';
                for (const [key, value] of Object.entries(regionMap)) {
                    if (value.includes(country)) {
                        region = key;
                        break;
                    }
                }
                let eid = '';
                let mcvid = '';
                if (typeof digitalData !== 'undefined' && digitalData.length > 0) {
                    if (this.containsValue(digitalData, "contactData")) {
                        eid = digitalData.filter((data) => data.contactData)[0].contactData.contactID;
                    }

                    if (this.containsValue(digitalData, "analyticsData")) {
                        mcvid = digitalData.filter((data) => data.analyticsData)[0].analyticsData.marketingCloudVisitorID;
                    }
                }
                const sessionState = {
                    id: this.generateRandomId(),
                    time: Date.now(),
                    chatLegalAccepted: false,
                    chatValidDate: 0,
                    currentTab: 'none',
                    outputAudioMuted: true,
                    voiceModeActive: false,
                    voiceModeEnabled: false,
                };

                const url = aiQueryEndpoint;
                const clientId = aiClientId;
                const clientSecret = aiClientSecret;
                const correlationId = aiCorrelationId + '-' + Date.now().toString();
                const aiPostBody = new FormData();
                const postBodyJson = {
                    query: this.keyword,
                    user_session_id: sessionState.id,
                    language: language,
                    region: region,
                    locale: locale,
                    isChatDebug: false,
                    driftEnabled: false,
                    current_page: window.location.href,
                    summarize_length: this.summarizeLength,
                    summarize_type: '',
                    page_context: '',
                    eid: eid,
                    mcvid: mcvid,
                    sessionState: sessionState,
                    source_app: 'searchqa',
                };
                aiPostBody.append('encoded_data', this.stringToBase64(JSON.stringify(postBodyJson)));
                const rockSigned = window.localStorage.getItem('rockSigned');
                if (rockSigned) {
                    aiPostBody.append('rockSigned', rockSigned);
                }

                const response = await fetch(url, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'client_id': clientId,
                        'client_secret': clientSecret,
                        'correlation_id': correlationId,
                    },
                    body: aiPostBody,
                });
                let aiResponse = '';
                const timeout = Date.now() + 180000;
                if (response.ok) {
                    const reader = response.body.getReader();
                    while (true) {
                        const value = await reader.read();
                        if (value.done || Date.now() > timeout) {
                            break;
                        }

                        let streamData = new TextDecoder().decode(value.value);
                        let data = '';

                        streamData = streamData.split('data: ');
                        streamData.forEach((line) => {
                            line = line.replace(/\r\n\r\n$/, '');
                            line = line.replace(/\r\n/g, '<br>');
                            if (line.trim() !== '[DONE]' && line.trim() !== '[END]') {
                                data += line;
                            }
                        });

                        aiResponse += data;
                        if (aiResponse.includes('#READY#')) {
                            aiResponse = aiResponse.replace('#READY#', '');
                            this.aiValidQuery = true;
                            const eventObject = {
                                event: 'ai-overview-status',
                                aiOverviewStatusData: {
                                    status: 'loading'
                                }
                            }
                            window.digitalData?.push(eventObject);
                            continue;
                        }
                        if (aiResponse.includes('#NO_ANSWER#')) {
                            // aiResponse = aiResponse.replace('#NO_ANSWER#', '');
                        } else if (aiResponse.includes('#QUERY_TOO_LONG#')) {
                            // aiResponse = aiResponse.replace('#QUERY_TOO_LONG#', '');
                        } else if (aiResponse.includes('#OUT_OF_LIMIT#')) {
                            // aiResponse = aiResponse.replace('#OUT_OF_LIMIT#', );
                        } else if (aiResponse.includes('#SERVICE_NOT_AVAILABLE#')) {
                            // aiResponse = aiResponse.replace('#SERVICE_NOT_AVAILABLE#', );
                        } else if (aiResponse.includes('#WARNING_DANGER#') || aiResponse.includes('#WARNING_CAREFUL#')) {
                            aiResponse = aiResponse.replace('#WARNING_DANGER#', '');
                            aiResponse = aiResponse.replace('#WARNING_CAREFUL#', '');
                        } else if (aiResponse.includes('#DRIFT_CONNECT#')) {
                            aiResponse = aiResponse.replace('#DRIFT_CONNECT#', '');
                        }
                        this.aiResponse = aiResponse;

                        this.aiLoading = false;
                    }
                }
                if (aiResponse) {
                    this.populateRelatedLinks(aiResponse);
                    this.aiResponse = this.markdownToHtml(aiResponse.split('<div')[0].replaceAll('<br/>', '').trim());
                    const eventObject = {
                        event: 'ai-overview-status',
                        aiOverviewStatusData: {
                            status: 'complete'
                        }
                    }
                    window.digitalData?.push(eventObject);
                }
            } catch (error) {
                console.warn('Error in fetchAiResults:', error);
            } finally {
                // Set up mutation observer to track AI response height changes
                const aiResponseElement = document.querySelector('.ai-summary__overview-content-text-container');
                if (aiResponseElement) {
                    this.aiResponseMaxHeightExpanded = aiResponseElement.scrollHeight;
                    const resizeObserver = new ResizeObserver(entries => {
                        for (const entry of entries) {
                            this.aiResponseMaxHeightExpanded = entry.target.scrollHeight;
                        }
                    });
                    resizeObserver.observe(aiResponseElement);
                }
            }
        },
        populateRelatedLinks(aiResponse) {
            // Create a temporary div to parse HTML string
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = aiResponse;

            // Get all anchor tags
            const links = tempDiv.getElementsByTagName('a');

            // Convert HTMLCollection to Array and map to objects with href and label
            this.relatedLinks = Array.from(links).map(link => ({
                href: link.getAttribute('href'),
                label: link.textContent.trim()
            }));
            this.aiRelatedLinksLoading = false;
        },
        generateRandomId() {
            return (
                Math.random().toString(36).substring(2, 15) +
                Math.random().toString(36).substring(2, 15)
            );
        },
        containsValue(arr, targetValue) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].hasOwnProperty(targetValue)) {
                    return true;
                }
            }
            return false;
        },
        stringToBase64(str) {
            const bytes = new TextEncoder().encode(str);
            const binString = Array.from(bytes, (byte) =>
                String.fromCodePoint(byte),
            ).join("");
            return btoa(binString);
        },

        markdownToHtml(markdown) {
            return markdown
                .split('<br>') // Split into lines for per-line processing
                .map(line => {
                    // Headings
                    if (/^###\s+/.test(line)) return `<h3>${line.replace(/^###\s+/, '')}</h3>`;
                    if (/^##\s+/.test(line)) return `<h2>${line.replace(/^##\s+/, '')}</h2>`;
                    if (/^#\s+/.test(line)) return `<h1>${line.replace(/^#\s+/, '')}</h1>`;

                    // Otherwise treat as paragraph
                    return line;
                })
                .join('<br>')
                // Inline styles
                .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
                .replace(/\*(.+?)\*/g, '<em>$1</em>')
                .replace(/~~(.+?)~~/g, '<del>$1</del>')
                .replace(/`(.+?)`/g, '<code>$1</code>');
        },
    },
});

app.mount(`#${searchResultAppId}`);
